import { useState } from "react";
import styled from "styled-components";
import theme from "../../theme/theme";
import Avatar from "../Base/Avatar";

const Wrapper = styled.button`
  display: flex;
  border-radius: 5px;
  border: 2px solid transparent;
  background-color: ${theme.colors.white};
  border-left-width: 10px;
  padding: 20px;
  box-sizing: border-box;
  min-width: 150px;
  width: 100%;
  height: ${(props) => props.height + "px"};

  &:hover {
    background-color: ${theme.colors.grayBg};
  }

  .strategiest-info {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .name {
      text-align: left;
      font-weight: bold;
      font-size: 1.2em;
    }

    .strategy {
      text-align: left;
      margin: 10px 0 20px;
      color: ${theme.colors.gray};
    }

    .bioLink {
      margin-top: 10px;
      color: ${theme.colors.primaryStrong};
    }
  }

  .inv {
    margin-left: auto;

    strong {
      color: ${theme.colors.primaryStrong};
    }
  }

  &.invested {
    border-color: ${theme.colors.primary};
    background-color: #fafeff;
  }
`;

const StrategistItem = ({
  strategistName,
  strategy,
  imgSrc,
  bioLink,
  invested,
  height,
}) => {
  const [isInvested, setIsInvested] = useState(invested);
  return (
    // Strategist selecting is commented for now
    // <Wrapper className={`${isInvested ? "invested" : ""}`} onClick={() => setIsInvested(!isInvested)}>
    <Wrapper
      className={`${isInvested ? "invested" : ""}`}
      onClick={() => setIsInvested(isInvested)}
      height={height}
    >
      <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
        <Avatar imgSrc={imgSrc} />
      </div>
      <div className="strategiest-info">
        <span className="name">{strategistName}</span>
        {/* <span className="strategy">{strategy}</span> */}
        <a className="bioLink" href={bioLink} target="_blank" rel="noreferrer">
          View Details
        </a>
      </div>
      <div className="inv">{isInvested ? <strong>INVESTED</strong> : null}</div>
    </Wrapper>
  );
};

export default StrategistItem;
